<template>
  <header class="bg-white z-20 fixed w-full shadow-xl py-2 sm:py-4 xl:py-8 px-2">
    <div class="flex relative">
      <header-burger></header-burger>
      <div class="flex-auto h-16 xl:h20 flex items-center 2xl:max-w-screen-xl 2xl:mx-auto">
        <a href="/" class="inline-block align-middle 2xl:-ml-24"><img class="h-12 ml-3 sm:h-16 xl:h-20 xl:ml-6 2xl:ml-0" src="/dist/img/onemilegrid-logo.png" alt="onemilegrid"></a>
      </div>
      <div class="hidden h-16 xs:flex items-center absolute right-0 top-0 mr-2 sm:mr-4">
        <a href="/contact-us" class="bg-brand-gray-dark hover:bg-brand-gray-mid2 uppercase text-white font-sans-bold font-semibold text-base tracking-tight py-3 px-5 rounded block w-full sm:w-auto inline-flex items-center justify-between">
          <svg class="fill-current w-4 h-4 sm:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16zm-4.37 9.1L20 16v-2l-5.12-3.9L20 6V4l-10 8L0 4v2l5.12 4.1L0 14v2l6.37-4.9L10 14l3.63-2.9z"/></svg>
          <span class="hidden sm:inline-block">Contact us</span>
        </a>
      </div>
    </div>
    <nav>
      <header-sidebar>
        <ul class="mt-20 sm:mt-24 xl:mt-32">
          <li v-for="link in links" :key="link.url">
            <a :href="link.url" :class="[ currentLocation == link.url ? 'text-white bg-brand-orange-500 hover:bg-brand-orange-500' : 'text-brand-gray-dark' ]" class="block px-4 py-3 font-bold text-sm hover:bg-brand-gray-light focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white">{{ link.text }}</a>
          </li>
        </ul>
        <ul class="mt-4">
          <li>
            <a href="mailto:info@onemilegrid.com.au" class="flex items-center px-4 py-3 text-sm hover:text-brand-orange-500 focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white">
              <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16zm-4.37 9.1L20 16v-2l-5.12-3.9L20 6V4l-10 8L0 4v2l5.12 4.1L0 14v2l6.37-4.9L10 14l3.63-2.9z"/></svg>
              <span>info@onemilegrid.com.au</span>
            </a>
          </li>
          <li>
            <a href="tel:0399398250" class="flex items-center px-4 py-3 text-sm hover:text-brand-orange-500 focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white">
              <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 18.35V19a1 1 0 0 1-1 1h-2A17 17 0 0 1 0 3V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4c0 .56-.31 1.31-.7 1.7L3.16 8.84c1.52 3.6 4.4 6.48 8 8l2.12-2.12c.4-.4 1.15-.71 1.7-.71H19a1 1 0 0 1 .99 1v3.35z"/></svg>
              <span>(03) 9939 8250</span>
            </a>
          </li>          
        </ul>        
      </header-sidebar>
    </nav>      
  </header>
</template>

<script>
export default {
  components: {
    'header-burger': () => import(/* webpackChunkName: "header-burger" */ './Header/Burger.vue'),
    'header-sidebar': () => import(/* webpackChunkName: "header-sidebar" */ './Header/Sidebar.vue'),
  },  
  data() {
    return {
      isOpen: false,
      links: [
        {
          text: 'Home',
          url: '/'
        },
        {
          text: 'About us',
          url: '/about-us'
        },
        {
          text: 'Services',
          url: '/services'
        },
        {
          text: 'Working at onemilegird',
          url: '/working-at-onemilegrid'
        },                                
        {
          text: 'Contact us',
          url: '/contact-us'
        },                
      ],
      currentLocation: window.location.pathname,   
    }
  },
}
</script>